// extracted by mini-css-extract-plugin
export var caption = "by_gX";
export var grey = "by_dp";
export var heading = "by_G";
export var image = "by_g";
export var left = "by_bT";
export var reverse = "by_dl";
export var right = "by_cv";
export var section = "by_d";
export var video = "by_gY";
export var videoContainer = "by_cF";
export var videoWrapper = "by_cG";